import styled, { css } from 'styled-components';

import { COLORS, GRADIENTS } from '../../theme/tokens';

export type DividerVariant = 'basic' | 'styled';
export type DividerOrientation = 'horizontal' | 'vertical';

/** Both directions share the same 1px hairline thickness. */
const THICKNESS = '1px';

/** Full-width line; `styled` fades to transparent at both ends, `basic` is flat. */
const horizontal = css<{ $variant: DividerVariant }>`
  width: 100%;
  height: ${THICKNESS};
  background: ${({ $variant }) => ($variant === 'styled' ? GRADIENTS.dividerStyledH : COLORS.hairline)};
`;

/** Stretches to fill a flex row's cross axis; same basic/styled treatment, rotated. */
const vertical = css<{ $variant: DividerVariant }>`
  align-self: stretch;
  width: ${THICKNESS};
  background: ${({ $variant }) => ($variant === 'styled' ? GRADIENTS.dividerStyledV : COLORS.hairline)};
`;

export const Root = styled.div<{ $variant: DividerVariant; $orientation: DividerOrientation }>`
  flex: none;
  border: 0;
  ${({ $orientation }) => ($orientation === 'vertical' ? vertical : horizontal)}
`;
